import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";

import LoginBase from "components/LoginBase/LoginBase";

import Button from "components/CustomButtons/CustomButton";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import logo from "assets/img/logo.png";

import styles from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.js";
import { getNew } from "../Services/NewsService";
import { Grid } from "@material-ui/core";
import CardBody from "components/Card/CardBody";
import CardFooter from "components/Card/CardFooter";

const useStyles = makeStyles(styles);

export default function LoginPage() {
  const [images, setImages] = useState([]);
  const [title, setTitle] = useState("");
  const [logoNew, setLogoNew] = useState("");
  const [completeNew, setCompleteNew] = useState("");
  const routeParams = useParams();
  const dispatch = useDispatch();
  const { id } = routeParams;

  const classes = useStyles();

  useEffect(() => {
    const token = localStorage.getItem("userToken");
    if (token) {
      if (window.location.href.includes("admin/new")) {
        getDataNew();
      }
    } else {
      window.location.replace("/auth/login-page");
    }
  }, [dispatch]);

  const getDataNew = async () => {
    const resultSubmit = await dispatch(getNew({ id: id }));
    if (!resultSubmit.payload.result) {
      //window.location.href = "/auth/login";
    } else {
      checkTypeNew(resultSubmit.payload.data);
    }
  };

  const checkTypeNew = (dataNew) => {
    setTitle(dataNew.new_data.title);
    switch (dataNew.new_data.type) {
      case "Article":
        const typeImage = getFormatImage(dataNew.new_resource_data[0]);
        setLogoNew(
          `data:image/${typeImage};base64,${dataNew.new_resource_data[0].resourceBase64}`
        );
        setCompleteNew(dataNew.new_data.complete_new);
        break;
      case "Photos":
        setImagesNew(dataNew);
        break;
      case "LinkVideo":
        setCompleteNew(
          <div style={{ textAlign: "center" }}>
            <a href={dataNew.new_resource_data[0].resource} target="_blank">
              {dataNew.new_resource_data[0].resource}
            </a>
          </div>
        );
        break;
      case "Document":
        const fileData = dataNew.new_resource_data[0];
        const blob = base64ToBlob(fileData.resourceBase64, fileData.mimeType);
        const url = URL.createObjectURL(blob);

        setCompleteNew(
          <div style={{ textAlign: "center" }}>
            <a
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              download={fileData.resource}
            >
              {fileData.resource}
            </a>
          </div>
        );
        break;
    }
    if (["LinkVideo", "Document"].includes(dataNew.new_data.type)) {
      setLogoNew(logo);
    }
  };

  const base64ToBlob = (base64, mime) => {
    const byteChars = atob(base64);
    const byteNumbers = new Array(byteChars.length)
      .fill()
      .map((_, i) => byteChars.charCodeAt(i));
    return new Blob([new Uint8Array(byteNumbers)], { type: mime });
  };

  const getFormatImage = (element) => {
    const lastCharacterType = element.resource.lastIndexOf(".");
    const typeResource = element.resource.substring(lastCharacterType + 1);
    return typeResource;
  };

  const setImagesNew = (dataNew) => {
    let photoList = [];
    dataNew.new_resource_data.forEach((element) => {
      const typeResource = getFormatImage(element);
      photoList.push({
        name: element.resource,
        resource: element.resourceBase64,
        type: typeResource,
      });
    });
    setImages(photoList);
  };

  return (
    <div className={classes.container}>
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={10}>
          <Card className={classes.cardSignup}>
            <CardHeader
              image
              className={`${classes.cardHeader} ${classes.textCenter}`}
              color="white"
            >
              <div className={classes.socialLine}>&nbsp;</div>
              {logoNew && (
                <img
                  src={logoNew}
                  alt="Photo New"
                  style={{ boxShadow: "none", width: "50%" }}
                />
              )}
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <h2 style={{ textAlign: "center" }}>{title}</h2>
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  {completeNew}
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  <GridContainer>
                    {images.map((img, index) => (
                      <GridItem xs={12} sm={12} md={4}>
                        <img
                          key={index}
                          src={`data:image/${img.type};base64,${img.resource}`}
                          alt={`imagen-${index}`}
                          width={"100%"}
                        />
                      </GridItem>
                    ))}
                  </GridContainer>
                </GridItem>
              </GridContainer>
            </CardBody>
            <CardFooter>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <Button
                    onClick={() => {
                      window.location.href = "/";
                    }}
                    style={{ backgroundColor: "#008670" }}
                    block
                  >
                    Back to Home
                  </Button>
                </GridItem>
              </GridContainer>
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}
